import type { IPatientEpisode } from '../../../interfaces/patientEpisode';
import { AbortableFetch } from '../../../../store/fetch';
import { translateKey } from '../../../../translate';
import { Component } from '../../../elements/Component';
import { PatientSideBarDetailCollapse } from '../PatientSidebarDetailCollapse';

interface IEpisodeJournalShortListProps {
    patientId: string;
}

interface IEpisodeJournalShortListState {
    patientEpisodes: IPatientEpisode[];
    total: number;
}

export class EpisodeJournalShortList extends Component<IEpisodeJournalShortListProps, IEpisodeJournalShortListState> {
    private abortableFetch = new AbortableFetch();

    constructor(props: IEpisodeJournalShortListProps, context?: {}) {
        super(props, context);

        this.state = {
            patientEpisodes: [],
            total: 0,
        };
    }

    public async componentDidMount() {
        this.loadEpisodes();
    }

    public async componentWillUnmount() {
        this.abortableFetch.abort();
    }

    public render() {
        return (
            <>
                {this.state.total > 0 && (
                    <PatientSideBarDetailCollapse
                        header={translateKey('journals.journals')}
                        icon="episodes"
                        listItems={this.state.patientEpisodes.map((result) => {
                            return { name: result.episode.valueDisplayName };
                        })}
                        overviewLink={`/patients/${this.props.patientId}?overview=episodeJournal`}
                        total={this.state.total}
                    />
                )}
            </>
        );
    }

    private async loadEpisodes() {
        const url = `/api/patients/${this.props.patientId}/episodes?limit=${5}`;
        const results = await this.abortableFetch.fetchJson(url, 'GET');
        await this.setState({ patientEpisodes: results.json.items, total: results.json.total });
    }
}
